
      // Signal that dependencies are loading
      window.dependenciesLoading = true;
      
      try {
        // ibira.js is a bundled npm dependency — Vite resolves this inline
        // module import from node_modules (no runtime CDN fetch).
        const { IbiraAPIFetchManager } = await import('ibira.js');
        window.IbiraAPIFetchManager = IbiraAPIFetchManager;
      } catch (error) {
        console.warn('⚠️ Failed to load IbiraAPIFetchManager:', error.message);
        // App will use fallback - guia.js has IbiraAPIFetchManagerFallback
      } finally {
        // Signal that dependencies are ready
        window.dependenciesLoading = false;
        window.dispatchEvent(new Event('dependencies-ready'));
      }
    